/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Auth_Error_Subscription_HtmlInputs */

const en_creator_auth_error_subscription_html = /** @type {(inputs: Creator_Auth_Error_Subscription_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There was an issue finding your subscription.<br><br><strong>Please sign up for a free trial to continue.</strong>`)
};

const fr_creator_auth_error_subscription_html = /** @type {(inputs: Creator_Auth_Error_Subscription_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un probleme est survenu lors de la recherche de votre abonnement.<br><br><strong>Veuillez vous inscrire pour un essai gratuit afin de continuer.</strong>`)
};

const de_creator_auth_error_subscription_html = /** @type {(inputs: Creator_Auth_Error_Subscription_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es gab ein Problem beim Auffinden Ihres Abonnements.<br><br><strong>Bitte registrieren Sie sich für eine kostenlose Testphase, um fortzufahren.</strong>`)
};

const it_creator_auth_error_subscription_html = /** @type {(inputs: Creator_Auth_Error_Subscription_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si è verificato un problema durante il rilevamento del tuo abbonamento.<br><br><strong>Iscriviti per una prova gratuita per continuare.</strong>`)
};

const ru_creator_auth_error_subscription_html = /** @type {(inputs: Creator_Auth_Error_Subscription_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возникла проблема с поиском вашей подписки.<br><br><strong>Пожалуйста, зарегистрируйтесь для бесплатной пробной версии, чтобы продолжить.</strong>`)
};

const es_creator_auth_error_subscription_html = /** @type {(inputs: Creator_Auth_Error_Subscription_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubo un problema al encontrar tu suscripción.<br><br><strong>Regístrate para una prueba gratuita y continúa.</strong>`)
};

const zh_cn2_creator_auth_error_subscription_html = /** @type {(inputs: Creator_Auth_Error_Subscription_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`找不到您的订阅信息。<br><br><strong>请注册免费试用以继续。</strong>`)
};

const ja_creator_auth_error_subscription_html = /** @type {(inputs: Creator_Auth_Error_Subscription_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションを見つける際に問題が発生しました。<br><br><strong>続行するには、無料トライアルにサインアップしてください。</strong>`)
};

const hi_creator_auth_error_subscription_html = /** @type {(inputs: Creator_Auth_Error_Subscription_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपकी सदस्यता खोजने में समस्या आ रही है।<br><br><strong>जारी रखने के लिए कृपया निःशुल्क परीक्षण के लिए साइन अप करें।</strong>`)
};

const pt_pt2_creator_auth_error_subscription_html = /** @type {(inputs: Creator_Auth_Error_Subscription_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocorreu um problema ao encontrar sua assinatura.<br><br><strong>Inscreva-se para um teste gratuito para continuar.</strong>`)
};

/**
* | output |
* | --- |
* | "There was an issue finding your subscription.<br><br><strong>Please sign up for a free trial to continue.</strong>" |
*
* @param {Creator_Auth_Error_Subscription_HtmlInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_auth_error_subscription_html = /** @type {((inputs?: Creator_Auth_Error_Subscription_HtmlInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Auth_Error_Subscription_HtmlInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_creator_auth_error_subscription_html(inputs)
	if (locale === "de") return de_creator_auth_error_subscription_html(inputs)
	if (locale === "it") return it_creator_auth_error_subscription_html(inputs)
	if (locale === "ru") return ru_creator_auth_error_subscription_html(inputs)
	if (locale === "es") return es_creator_auth_error_subscription_html(inputs)
	if (locale === "zh-CN") return zh_cn2_creator_auth_error_subscription_html(inputs)
	if (locale === "ja") return ja_creator_auth_error_subscription_html(inputs)
	if (locale === "hi") return hi_creator_auth_error_subscription_html(inputs)
	if (locale === "pt-PT") return pt_pt2_creator_auth_error_subscription_html(inputs)
	return en_creator_auth_error_subscription_html(inputs)
});